import { Component, DoCheck, EventEmitter, Input, IterableDiffers, OnInit, Output } from '@angular/core';
import { Channel } from 'icreate/common/models/channel';
import { getDigitalTypesSet } from 'icreate/common/models/channel-type';

@Component({
    selector: 'app-channel-search-table',
    templateUrl: './channel-search-table.component.html',
    styleUrls: ['./channel-search-table.component.css'],
    standalone: false,
})
export class ChannelSearchTableComponent implements DoCheck, OnInit {
    @Input() filteredChannelList: Channel[];
    @Input() selectedChannels: Channel[];
    @Input() multipleSelection: boolean = false;
    @Input() maxChannels: number = 24;
    @Input() preSelectedChannelsCount: number = 0;
    @Input() showCounter: boolean = false;

    @Output() onChannelSelected: EventEmitter<Channel[]> = new EventEmitter();

    dataSource: any[];
    totalChannelsCount: number = 0;
    availableChannelCount: number = this.maxChannels;

    readonly DEFAULT_PAGE_LIMIT: number = 5;
    readonly DEFAULT_DISPLAY_COLUMNS: string[] = ['checkbox', 'Ch. Name', 'Ch. Type'];

    paginator: Boolean = false;
    numberOfPages: number = 0;
    displayedPageLimit: number = this.DEFAULT_PAGE_LIMIT;
    displayedColumns: string[] = this.DEFAULT_DISPLAY_COLUMNS;

    iterableDiffer;

    constructor(private iterableDiffers: IterableDiffers) {
        this.iterableDiffer = iterableDiffers.find([]).create(null);
    }

    ngOnInit(): void {
        this.availableChannelCount = this.maxChannels - this.preSelectedChannelsCount;
        this.totalChannelsCount = this.preSelectedChannelsCount;
        this.showCounter = this.multipleSelection ? true : false;
    }

    ngDoCheck() {
        let changes = this.iterableDiffer.diff(this.filteredChannelList);
        if (changes) {
            this.dataSource = this.filteredChannelList.sort((a, b) =>
                a.fcuData.fcuChannelId.localeCompare(b.fcuData.fcuChannelId, ['en', 'jp'], {
                    numeric: true,
                    sensitivity: 'variant',
                })
            );
        }
    }

    checkChannel(channel, boxClicked) {
        if (channel.checked && !boxClicked) {
            this.unselectChannel(channel.id);
        } else if (!channel.checked && boxClicked) {
            this.selectedChannels = this.selectedChannels.filter(selChannel => selChannel.id !== channel.id);
        } else if (channel.checked && boxClicked) {
            if (this.selectedChannels.length > 0 && !this.multipleSelection) {
                this.unselectChannel(this.selectedChannels[0].id);
            } else if (this.multipleSelection && this.selectedChannels.length >= this.availableChannelCount) {
                return;
            }
            this.selectedChannels.push(channel);
        } else if (!channel.checked && !boxClicked) {
            if (this.selectedChannels.length > 0 && !this.multipleSelection) {
                this.unselectChannel(this.selectedChannels[0].id);
            } else if (this.multipleSelection && this.selectedChannels.length >= this.availableChannelCount) {
                return;
            }
            channel.checked = true;
            this.totalChannelsCount++;
            this.selectedChannels.push(channel);
        }
        this.totalChannelsCount = this.preSelectedChannelsCount + this.selectedChannels.length;
        this.onChannelSelected.emit(this.selectedChannels);
    }

    unselectChannel(channelId) {
        this.selectedChannels = this.selectedChannels.filter(selChannel => selChannel.id !== channelId);

        if (this.dataSource) {
            this.dataSource.forEach(channel => {
                if (channel.id === channelId) {
                    channel.checked = false;
                }
            });
        }
    }

    channelIsDigital(channelType): boolean {
        return getDigitalTypesSet().has(channelType);
    }

    getCounter() {
        return this.showCounter ? this.totalChannelsCount + '/' + this.maxChannels : '';
    }

    getScaledMeasureRange(fcuData) {
        const scale = fcuData?.scale;
        const divisor = !scale || scale === 0 ? 1 : scale;

        const min = (fcuData?.measurableRange?.min ?? 0) / divisor;
        const max = (fcuData?.measurableRange?.max ?? 0) / divisor;

        return `${min}/${max}`;
    }
}
